export class Status {
  constructor(public id = '1', public displayLabel = 'Active', public code = 'ACTIVE') {}
}
